// All global variables and configuration setting

const appConfig = {
  // UI colors
  colors: {
    headerTheme: "bg-gradient-to-r from-blue-950 to-[#1E40AF] ",
    button:"bg-gradient-to-r from-blue-700 via-blue-500 to-blue-700",
  },
  

  // Text content  for footer
  footerText: {
    address: "3rd Floor, C-7 Madhu Vihar,Near Sai Chowk, East Delhi – 110092",
    contactNumber: "+91 81789 74929",
    email: "support@marketanalysisacademy.com",
  },
};

export default appConfig;
